import React from 'react'
import { PropTypes } from 'prop-types'
import ShowMore from '../../common/components/show_more/show_more_component'
import { withNamespaces } from "react-i18next"
import { compose } from 'redux'

export class Description extends React.Component {
  render() {
    const { t } = this.props
    return (
      <React.Fragment>
        {this.props.roomInfo &&
          <div>
            {/* <h2>{ t('description.about_room') }</h2> */}
            <ShowMore>{this.props.roomInfo}</ShowMore>
          </div>
        }
        {this.props.propertyInfo &&
          <div style={{ marginTop: 24 }}>
            <h2>{ t('description.about_property') }</h2>
            <ShowMore>{this.props.propertyInfo}</ShowMore>
          </div>
        }
      </React.Fragment>
    )
  }
}

Description.propTypes = {
  roomInfo: PropTypes.string,
  propertyInfo: PropTypes.string
}

Description.defaultProps = {
  roomInfo: '',
  propertyInfo: ''
}

export default compose( withNamespaces('listings') )(Description)
